<template>
  <div>
    <el-radio-group v-model="formData.resource">
      <el-radio v-for="(item, index) in datalead[0]?datalead[0].sysPermissionList:[]" :key="index" :label="item.permissionId">{{ item.permissionName }}</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formData: {
        resource: ''
      }
    };
  },
  created () {
  },
  props: {
    datalead: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    },
    trastlist: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    }
  },
  watch: {
    datalead () {
    },
    trastlist () {
      this.formData.resource = this.trastlist.length !== 0 ? this.trastlist[0].sysPermissionList[0].permissionId : '';
    }
  },
  mounted () {
    this.formData.resource = this.trastlist.length !== 0 ? this.trastlist[0].sysPermissionList[0].permissionId : '';
  }
};
</script>

<style scoped lang='scss'>
</style>
